// extracted by mini-css-extract-plugin
export default {"switch":"demoPortalSwitch_switch__GsGZ7","switch__shadow":"demoPortalSwitch_switch__shadow__NhGmz","slideTransition":"demoPortalSwitch_slideTransition__iFklz"};